import axios from './axios_api';
import * as url from './api.constant';
export const loadTeamMembers = async payload => {
  return await axios.post(url.URL_TEAM_MEMBERS, payload);
};

export const handleSuspension = async payload => {
  return await axios.post('asset/list/suspension/alter', payload);
};
